import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SystemLogsUIHelpers";

const SystemLogsUIContext = createContext();

export function useSystemLogsUIContext() {
  return useContext(SystemLogsUIContext);
}

export const SystemLogsUIConsumer = SystemLogsUIContext.Consumer;

export function SystemLogsUIProvider({ systemLogsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openExceptionModal: systemLogsUIEvents.openExceptionModal
  };

  return (
    <SystemLogsUIContext.Provider value={value}>
      {children}
    </SystemLogsUIContext.Provider>
  );
}